<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
          <el-breadcrumb-item>权限设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="userRole" label-width="160px" size="medium">
        <el-form-item label="名称">
          <el-col :span="12">
            <el-input v-model="userRole.name" ></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="数据范围">
          <el-col :span="12">
            <el-select v-model="userRole.type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="权限">
          <el-col :span="12">
            <el-tree
              :data="permissions"
              show-checkbox
              node-key="id"
              ref="tree"
              :check-strictly="false"
              @check-change="handleNodeClick"
              :default-expanded-keys="[2, 3]"
              :default-checked-keys="defaultCheckedKeys"
              :props="defaultProps">
            </el-tree>
          </el-col>
        </el-form-item>  
        <el-form-item >
          <el-col :span="12">
            <el-button type="primary" @click="SaveUserRoleInfo">确 定</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  export default {
    props:{
    },
    data (){
      return {
        userRole:{},
        options: [{
          value:0,
          label: '总部'
        }, {
          value:1,
          label: '代理',
          disabled: true
        }, {
          value:2,
          label: '商家'
        }, {
          value:3,
          label: '门店'
        }],
        permissions:[],
        defaultProps: {
          children: 'permissions',
          label: 'name'
        },
        defaultCheckedKeys:[]
      }
    },
    computed:{
    
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/UserRole/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.userRole = resp.data.userRole
        that.permissions = resp.data.permissions
        that.defaultCheckedKeys = that.userRole.rolePermissions.split(',')
      })
    },
    methods:{
      handleNodeClick:function(data, checked, indeterminate){
        var arr1 = this.$refs.tree.getCheckedKeys();
        var arr2 = this.$refs.tree.getHalfCheckedKeys();
        this.userRole.rolePermissions = arr1.join(",")
        this.userRole.menuPermissions = arr1.concat(arr2).join(",")
      }, 
      SaveUserRoleInfo:function(){      
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/UserRole/Save',         
          data:this.userRole
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },      
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'userRole',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>